export default __webpack_public_path__ + "static/media/logo-b.75870d96.jpg";